import { client } from 'app/http';

export const markSsoProviderSession = async () => {
  await client.post('/auth/sso/session');
};
